import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateSubCategory from "../../components/ProductManager/SubCategory/UpdateSubCategory";

export const UpdateSubCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateSubCategory />
        </div>
      </div>
    </div>
  );
};
